import { getParameterByName } from '../helpers';
import { api } from './api';

export function getCourseInfo(courseID, callback) {
  api.ibledxcourses.getCourseMeta({ course_key: courseID }, function (data) {
    callback(data);
  });
}

export function getEnrollmentStatus(courseID, callback) {
  const data = {
    course_id: courseID,
  };
  api.ibledxcourses.fetchEnrollStatus(data, function (data) {
    callback(data);
  });
}

export function enrollToCourse(callback) {
  const data = {
    course_id: getParameterByName('course_id'),
  };
  api.ibledxcourses.enrollToCourse(data, function (data) {
    callback(data);
  });
}
